import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../../services/storage.service';
import { appConfig } from 'src/app/models/constants';
import { ApplicationInsightsService } from '../app-insights/app-insights.service';
import { SharedService } from '../shared/shared.service';
import { ConfirmationService } from 'primeng/api';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private auth: MsalService,
        private storageService: StorageService,
        private appInsights: ApplicationInsightsService, private sharedService: SharedService,
        private confirmationService: ConfirmationService) {
    }
    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const scopes = ['user.read', 'profile'];

        this.auth.getLogger().verbose('Url: ' + req.url + ' maps to scopes: ' + scopes);
        let tenantId = this.storageService.decodeValue("X-TENANT-ID");
        let countrySelected
        if (this.storageService?.decodeValue('Country')) {
            countrySelected = this.storageService?.decodeValue('Country');
        } else {
            this.sharedService.countryCodeChangeObserve().subscribe((res) => {
                countrySelected = res;
            })
        }
        let storedToken = this.storageService.getSessionStorage('msal.idtoken');
        let tokenExpiry = this.storageService.getCookie('msal.idTokenExpiry');
        if (!scopes) {
            return next.handle(req);
        } else if (storedToken && tokenExpiry) {
            const header = {};
            header['Authorization'] = storedToken ? `Bearer ${storedToken}` : '';

            if (tenantId != 'NA' && tenantId != '' && tenantId != 'undefined' && tenantId != undefined && tenantId != null && tenantId != 'null') {
                header["X-TENANT-ID"] = tenantId;
            } 
            
            if (req.body != null && req.body != undefined && req.body != 'undefined' && req.body != 'null' && req.body != '' 
                && countrySelected != 'KSA' && !(req.body instanceof FormData)) {
                if (Object.keys(req.body).length > 0 && req?.body?.map !== undefined && !Array.isArray(req.body)) {
                    header["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
                } else {
                    header["Content-Type"] = "application/json";
                }
            }

            if (countrySelected != 'NA' && countrySelected != '' && countrySelected != 'GBL' && countrySelected != 'undefined' && countrySelected != undefined && countrySelected != null && countrySelected != 'null') {
                header["Country"] = countrySelected;
            } 
            const authReq = req.clone({
                setHeaders: header,
                body: req.body
            });
            return next.handle(authReq).pipe(tap((evt: any) => {
                if (evt instanceof HttpResponse) {
                }
                if (appConfig.appConfigService?.appInsights?.enable) {
                    if (evt.status !== undefined) {
                        let protocol = window.location.protocol;
                        this.appInsights.trackTrace({
                            message: `${req.method},${req.url},${evt.status},${protocol},${req.body}`
                        })
                    }
                }
            }), catchError((err: any) => {
                if (appConfig.appConfigService?.appInsights?.enable) {
                    let protocol = window.location.protocol;
                    this.appInsights.trackTrace({
                        message: `${req.method},${req.url},${err?.status?.toString()},${protocol},${req.body}`
                    })
                }
                if (err.status === 401) {
                    alert("Session expired. Please login again.");
                    this.storageService.unAuthUserFound();
                }
                if (err.status === 409) {
                    this.storageService.concurrFound.next(true);
                }
                return throwError(() => err);
            }));
        } else {
            alert("Session expired. Please login again.");
            this.storageService.unAuthUserFound();
        }
    }
}
